import React from 'react'
import { Switch as MuiSwitch, SwitchOwnerState, SwitchOwnProps } from '@mui/base/Switch'
import clsx from 'clsx'
import classes from './Switch.module.scss'

export type SwitchProps = SwitchOwnProps & {
  color?: 'primary' | 'success' | 'neutral'
  variant?: 'solid'
  className?: string
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
}

const Switch = ({ className, color = 'primary', variant = 'solid', ...props }: SwitchProps) => {
  const slotProps = {
    root: (ownerState: SwitchOwnerState) => ({
      className: clsx(className, classes.root, {
        [classes.primary]: color === 'primary',
        [classes.success]: color === 'success',
        [classes.neutral]: color === 'neutral',
        [classes.solid]: variant === 'solid',
        [classes.disabled]: ownerState.disabled,
      }),
    }),
    track: () => ({
      className: clsx(classes.track),
    }),
    thumb: () => ({
      className: clsx(classes.thumb),
    }),
    input: () => ({
      className: clsx(classes.input),
    }),
  }
  return <MuiSwitch slotProps={slotProps} {...props} />
}

export default Switch
